import { useEffect, useState } from 'react';

import { IBlogPostTransformed } from '../../services/api';
import { useContentfulFetchers } from '../../context/ContentfulContext';

export function useProjectQuery(slug: string | undefined) {
  const { fetchProject } = useContentfulFetchers();
  const [data, setData] = useState<IBlogPostTransformed | undefined>();
  const [isLoading, setIsLoading] = useState(() => Boolean(slug));
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!slug) {
      setData(undefined);
      setIsLoading(false);
      setIsError(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);
    setIsError(false);
    fetchProject(slug)
      .then((result) => {
        if (!cancelled) {
          setData(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIsError(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [slug, fetchProject]);

  return { data, isLoading, isError };
}
